/** A failed first read stays actionable while automatic retries run. */
export function showProductionLoading(input: { ready: boolean; failed: boolean; silent: boolean }) {
  return !input.ready && !(input.failed && input.silent);
}

/** Plan reconciliation must not hold the first read hostage. It is a mutation:
 * run it once, observe failures, and reread only after that attempt completes. */
export async function loadProductionWorkspace(input: {
  read: () => Promise<void>;
  synchronize?: () => Promise<{ synchronized: boolean }>;
  isCurrent: () => boolean;
  onSynchronizationFailure: (error: unknown) => void;
}) {
  const firstRead = input.read();
  if (!input.synchronize) return firstRead;
  const synchronized = input.synchronize().then(
    (result) => result.synchronized,
    (error: unknown) => {
      if (input.isCurrent()) input.onSynchronizationFailure(error);
      return false;
    },
  );
  const [, changed] = await Promise.all([firstRead, synchronized]);
  if (changed && input.isCurrent()) await input.read();
}
